<script setup>
import AppLayout from"@/Layouts/AppLayout.vue";
import Button from"primevue/button";
import { Link } from"@inertiajs/vue3";
</script>

<template>
    <AppLayout title="Commande Annulée">
        <div class="flex justify-center items-center h-full">
            <div class="text-center p-4">
                <i
                    class="pi pi-times p-4 bg-red-500 rounded-full text-white text-2xl mb-4"
                ></i>
                <h1 class="text-3xl font-bold text-red-500">
                    Commande Annulée
                </h1>
                <p class="text-gray-500">Votre commande a bien été annulée.</p>
            </div>
        </div>
        <template v-if="$page.props.auth.user" #bottom>
            <div class="flex w-full justify-center">
                <Link :href="route('dashboard')">
                    <Button label="Retour à l'accueil" />
                </Link>
            </div>
        </template>
    </AppLayout>
</template>
